<template>
  <div>
    <div class="d-flex align-items-center justify-content-between mb-4">
      <h3 class="mb-0">Valutazione immobile</h3>
      <div>
        <button v-if="isEditing" class="btn btn-secondary mr-3" @click="cancel" :disabled="isSaving">Annulla</button>
        <button v-if="isEditing" class="btn btn-primary" @click="confirmSave" :disabled="isSaving">
          <span v-if="isSaving" class="mr-2">
            <div class="spinner-border text-light" style="height: 1rem; width: 1rem; border-width: 0.15em" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </span>
          Salva
        </button>
        <button v-if="!isEditing" class="btn btn-outline-primary" @click="edit">Modifica</button>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8">
        <div class="card custom-card gray mb-4">
          <div class="card-header">
            <div class="row w-100 no-gutters align-items-center">
              <div class="col-6">PREZZO</div>
              <div class="col-4">€/MQ</div>
              <!-- <div class="col-2">AVM</div> -->
              <div class="col-2"></div>
            </div>
          </div>
          <div class="card-body">
            <div class="row no-gutters align-items-center pb-1 mb-1 border-bottom">
              <div class="col-6">Prezzo minimo OMI</div>
              <div class="col-4 d-flex pr-4">
                <span class="mr-1">€</span>
                <span v-if="!isEditing">{{ numf(property.omi_min) }}</span>
                <currency-input v-else short v-model="property.omi_min" />
              </div>
              <div class="col-2"></div>
            </div>
            <div class="row no-gutters align-items-center pb-1 mb-1 border-bottom">
              <div class="col-6">Prezzo massimo OMI</div>
              <div class="col-4 d-flex pr-4">
                <span class="mr-1">€</span>
                <span v-if="!isEditing">{{ numf(property.omi_max) }}</span>
                <currency-input v-else short v-model="property.omi_max" />
              </div>
              <div class="col-2"></div>
            </div>
            <div class="row no-gutters align-items-center pb-1 mb-1 border-bottom">
              <div class="col-6">Prezzo massimo Civile Ottimo OMI</div>
              <div class="col-4 d-flex pr-4">
                <span class="mr-1">€</span>
                <span v-if="!isEditing">{{ numf(property.omi_max_civil) }}</span>
                <currency-input v-else short v-model="property.omi_max_civil" />
              </div>
              <div class="col-2"></div>
            </div>
          </div>
        </div>

        <!-- omi_link -->
        <div class="row mb-4">
          <div class="col-4">Link OMI</div>
          <div class="col-8 d-flex">
            <a :href="property.omi_link" target="_blank" class="btn btn-link p-0" v-if="!isEditing">{{ property.omi_link == null || property.omi_link == "" ? "" : "Vedi" }}</a>
            <input v-else type="text" class="form-control" v-model="property.omi_link" />
          </div>
        </div>

        <!-- client_request_price -->
        <div class="row mb-4">
          <div class="col-4">Richiesta</div>
          <div class="col-8">
            <div v-if="!isEditing" class="d-flex">
              <span class="mr-1">€</span>
              <span>{{ numf(property.client_request_price) }}</span>
            </div>
            <currency-input v-else short v-model="property.client_request_price" />
          </div>
        </div>

        <!-- negotiable_price -->
        <div class="row mb-4">
          <div class="col-4">Prezzo trattabile</div>
          <div class="col-8">
            <span v-if="!isEditing">{{ property.negotiable_price == 1 ? "SI" : "NO" }}</span>
            <div v-else class="form-row w-100">
              <div class="col-sm mb-2 mb-sm-0">
                <div class="form-control">
                  <div class="custom-control custom-radio">
                    <input
                      type="radio"
                      class="custom-control-input"
                      name="negotiable_price"
                      id="negotiable_price_yes"
                      :checked="property.negotiable_price == 1"
                      @input="property.negotiable_price = $event.target.checked ? 1 : 0"
                    />
                    <label class="custom-control-label" for="negotiable_price_yes">Si</label>
                  </div>
                </div>
              </div>
              <div class="col-sm mb-2 mb-sm-0">
                <div class="form-control">
                  <div class="custom-control custom-radio">
                    <input
                      type="radio"
                      class="custom-control-input"
                      name="negotiable_price"
                      id="negotiable_price_no"
                      :checked="property.negotiable_price != 1"
                      @input="property.negotiable_price = $event.target.checked ? 0 : 1"
                    />
                    <label class="custom-control-label" for="negotiable_price_no">No</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- actual_agency_price -->
        <div class="row mb-4">
          <div class="col-4">Prezzo a cui si può comprare</div>
          <div class="col-8">
            <div v-if="!isEditing" class="d-flex">
              <span class="mr-1">€</span>
              <span>{{ numf(property.actual_agency_price) }}</span>
            </div>
            <currency-input v-else short v-model="property.actual_agency_price" />
          </div>
        </div>

        <!-- after_restoration_agency_price -->
        <div class="row mb-4">
          <div class="col-4">Stima ARV</div>
          <div class="col-8">
            <div v-if="!isEditing" class="d-flex">
              <span class="mr-1">€</span>
              <span>{{ numf(property.after_restoration_agency_price) }}</span>
            </div>
            <currency-input v-else short v-model="property.after_restoration_agency_price" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { numf } from "@/helpers/helper";
export default {
  data() {
    return {
      isSaving: false,
      isEditing: false,
      property: null,
      propertyBk: null
    };
  },

  beforeMount() {
    this.property = this.$page.props.property;
  },

  methods: {
    numf,

    edit() {
      this.propertyBk = _.cloneDeep(this.property);
      this.isEditing = true;
      $('[data-toggle="tooltip"]').tooltip();
    },
    confirmSave() {
      this.$confirm({
        message: `Salvare i la valutazione?`,
        button: {
          no: "No",
          yes: "Si"
        },
        callback: confirm => {
          if (confirm) {
            this.save();
          }
        }
      });
    },
    async save() {
      this.isSaving = true;

      try {
        const response = await this.$inertia.put(`/admin/properties/${this.property.id}/evaluation`, this.property);
      } catch (error) {
        console.log(error);
      }

      this.isSaving = false;
      this.isEditing = false;
    },
    cancel() {
      this.property = _.cloneDeep(this.propertyBk);
      this.isEditing = false;
    }
  }
};
</script>
